import React from "react";
import ShiftExchangeViewComponent from "./ShiftExchangeViewComponent";
import MarkForExchangeComponent from "./MarkForExchangeComponent";
import { ReactRenderer } from "./lib/ReactRenderer";
export default class ShiftExchangeComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            shiftexchange: (this.props.shiftexchangejson)
                ? JSON.parse(this.props.shiftexchangejson)
                : this.props.shiftexchange
        };
        this.updateShiftExchange = this.updateShiftExchange.bind(this);
        this.cancelCallback = this.cancelCallback.bind(this);
    }
    updateShiftExchange(shiftExchange) {
        this.setState({ shiftexchange: shiftExchange });
        if (this.props.onsuccess) {
            this.props.onsuccess(shiftExchange);
        }
    }
    cancelCallback() {
        this.setState({ shiftexchange: null });
        if (this.props.onsuccess) {
            this.props.onsuccess(null);
        }
    }
    render() {
        return ((this.state.shiftexchange && this.state.shiftexchange.id !== 0)
            ? React.createElement(ShiftExchangeViewComponent, { shiftexchange: this.state.shiftexchange, variant: this.props.variant, oncancelled: this.cancelCallback })
            : React.createElement(MarkForExchangeComponent, { shiftid: this.props.shiftid, variant: this.props.variant, when: this.props.when, detail: this.props.detail, onsuccess: this.updateShiftExchange }));
    }
}
ReactRenderer.render("shiftexchangecomponent", (elem) => React.createElement(ShiftExchangeComponent, Object.assign({}, (elem.dataset))));
